var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};



//////////////////
// WEBPACK FOOTER
// /Users/v625154/work/perspective/node_modules/core-js/modules/_shared-key.js
// module id = 64
// module chunks = 0